import { computed, ref } from 'vue'
import moment from 'moment'
import { TIMEZONE, BOOKING } from '@/config/constants'

// by convention, composable function names start with "use"
export function useDatePicker() {
  const dateInternal = ref(null)
  const dateTime = ref(null)
  const datePicker = ref(null)
  const timeSetFirstTime = ref(true)
  const initialDate = ref(null)
  const datePickerRef = ref(null)

  const handleInternal = (value) => {
    if (timeSetFirstTime.value && value) {
      initialDate.value = new Date(value.setHours(0, 0))
      datePicker.value = initialDate.value
      timeSetFirstTime.value = false
    } else if (!timeSetFirstTime.value && value) {
      initialDate.value = value
    }
  }

  const toDay = computed(() => {
    const rightNow = new Date()
    const nowRome = moment(Date.parse(rightNow.toLocaleString('en-US', { timeZone: TIMEZONE })))

    return nowRome.hours() < BOOKING.CUTOFF_HOUR
  })

  const minDate = computed(() => {
    const rightNow = new Date()
    const nowRome = moment(Date.parse(rightNow.toLocaleString('en-US', { timeZone: TIMEZONE })))

    if (toDay.value) {
      return nowRome.toDate()
    }

    return nowRome.add(1, 'days').toDate()
  })

  const minTime = computed(() => {
    const selectedNow = dateInternal.value ?? new Date()

    const selectedNowRome = moment(
      Date.parse(selectedNow.toLocaleString('en-US', { timeZone: TIMEZONE }))
    )
    const nowRome = moment(Date.parse(new Date().toLocaleString('en-US', { timeZone: TIMEZONE })))
    if (
      selectedNowRome.dayOfYear() - nowRome.dayOfYear() === 1 ||
      (selectedNowRome.dayOfYear() - nowRome.dayOfYear() === 0 &&
        nowRome.hours() < BOOKING.NEXT_DAY_CUTOFF_HOUR)
    ) {
      return { hours: BOOKING.NEXT_DAY_MIN_HOUR, minutes: 0 }
    }

    if (selectedNowRome.dayOfYear() - nowRome.dayOfYear() === 0 && toDay.value) {
      return { hours: nowRome.hours(), minutes: nowRome.minutes() }
    }

    return { hours: 0, minutes: 0 }
  })

  // const parseDate = (value) => {
  //   console.log(value)
  // }

  const dateFormat = (date) => {
    return moment(date).format('DD/MM/YYYY H:mm')
  }

  return {
    dateInternal,
    minDate,
    minTime,
    dateTime,
    datePicker,
    initialDate,
    handleInternal,
    dateFormat,
    datePickerRef
  }
}

export function useTimeOptions() {
  const timeOptions = ref([])
  timeOptions.value = Array.from({ length: 24 }, (_, i) => i)
    .map((hour) =>
      [0, 15, 30, 45].map(
        (minute) => `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`
      )
    )
    .flat()
  return { timeOptions }
}
